import React from 'react';

import { LinkButton, StandardButton } from '@eika/button';

import piwik from '@/piwik/piwik';

type FooterProps = {
    isSettingPin: boolean;
    hasSetPin: boolean;
    isError: boolean;
    failedSetPin: boolean;
    formCancel: string;
    formNext: string;
    formBack: string;
    confirmChangePin: string;
    cancel: () => void;
    next: () => void;
    back: () => void;
    submitNewPinEntry: () => void;
};

const Footer = ({
    isSettingPin,
    hasSetPin,
    isError,
    failedSetPin,
    formCancel,
    formNext,
    formBack,
    confirmChangePin,
    cancel,
    next,
    back,
    submitNewPinEntry,
}: FooterProps) => {
    if (hasSetPin && (!isError || !failedSetPin)) {
        return (
            <div className="replace-card-new-pin-entry-form__form__footer">
                <LinkButton
                    data-track-id={piwik.replaceCard.pinChangeDecisionCancel.dataTrackId}
                    data-track-linkname={piwik.replaceCard.pinChangeDecisionCancel.dataTrackLinkname}
                    id={piwik.replaceCard.pinChangeDecisionCancel.dataTrackId}
                    onClick={cancel}
                >
                    {formCancel}
                </LinkButton>
                <StandardButton
                    data-track-id={piwik.replaceCard.replaceExistingCardNext.dataTrackId}
                    data-track-linkname={piwik.replaceCard.replaceExistingCardNext.dataTrackLinkname}
                    id={piwik.replaceCard.replaceExistingCardNext.dataTrackId}
                    onClick={next}
                >
                    {formNext}
                </StandardButton>
            </div>
        );
    }

    return (
        <div className="replace-card-new-pin-entry-form__form__footer">
            <LinkButton
                data-track-id={piwik.replaceCard.replaceExistingCardCancel.dataTrackId}
                data-track-linkname={piwik.replaceCard.replaceExistingCardCancel.dataTrackLinkname}
                disabled={isSettingPin}
                id={piwik.replaceCard.replaceExistingCardCancel.dataTrackId}
                onClick={back}
            >
                {formBack}
            </LinkButton>
            <StandardButton
                onClick={submitNewPinEntry}
                disabled={isSettingPin}
                data-track-id={piwik.replaceCard.newPinConfirm.dataTrackId}
                data-track-linkname={piwik.replaceCard.newPinConfirm.dataTrackLinkname}
                id={piwik.replaceCard.newPinConfirm.dataTrackId}
            >
                {confirmChangePin}
            </StandardButton>
        </div>
    );
};

export default Footer;
